<app-header></app-header>

  <div class="container my-5 form-container shadow-sm">
    <div class="form-container">
      <div class="form-header text-center p-4">
        <img src="ExbeBranco.png" alt="Logo Exbe" height="80" class="mb-3">
        <h2 class="mb-1">Cadastro de Novo Usuário</h2>
        <p class="text-white-50">Preencha os dados abaixo para criar uma nova conta.</p>
      </div>

      <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
        <div class="form-body p-4">
          <!-- Navegação entre abas -->
          <ul class="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="pills-basicos-tab" data-bs-toggle="pill" data-bs-target="#pills-basicos" type="button" role="tab">1. Dados Básicos</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-acesso-tab" data-bs-toggle="pill" data-bs-target="#pills-acesso" type="button" role="tab">2. Acesso</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-pessoal-tab" data-bs-toggle="pill" data-bs-target="#pills-pessoal" type="button" role="tab">3. Dados Pessoais</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="pills-contato-tab" data-bs-toggle="pill" data-bs-target="#pills-contato" type="button" role="tab">4. Contato e Endereço</button>
            </li>
          </ul>

          <div class="tab-content" id="pills-tabContent">
            <!-- Aba 1: Dados Básicos -->
            <div class="tab-pane fade show active" id="pills-basicos" role="tabpanel">
              <div formGroupName="dadosBasicos" class="row g-3">
                <div class="col-12">
                  <label for="nome" class="form-label">Nome Completo</label>
                  <input type="text" id="nome" class="form-control" formControlName="nome">
                </div>

                <div class="col-md-6">
                  <label for="idTipoUsuario" class="form-label">Tipo de Documento</label>
                  <select id="tipoUsuario" formControlName="idTipoUsuario" class="form-control">
                    <option value="Selecione..." selected>Selecione...</option>
                    <option *ngFor="let tipo of tiposDocumento" [value]="tipo.id">{{ tipo.nome }}</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="cpfCnpj" class="form-label">CPF/CNPJ</label>
                  <input type="text" id="cpfCnpj" class="form-control" formControlName="cpfCnpj">
                </div>
              </div>
            </div>

            <!-- Aba 2: Acesso -->
            <div class="tab-pane fade" id="pills-acesso" role="tabpanel">
              <div formGroupName="autenticacao" class="row g-3">
                <div class="col-md-6">
                  <label for="email-acesso" class="form-label">E-mail de Acesso</label>
                  <input type="email" id="email-acesso" class="form-control" formControlName="email">
                </div>
                <div class="col-md-6">
                  <label for="senha" class="form-label">Senha</label>
                  <div class="input-wrapper position-relative">
                      <input [type]="mostrarSenha ? 'text' : 'password'" id="senha" class="form-control" formControlName="senha">

                    <i
                      class="bi toggle-eye"
                      [ngClass]="mostrarSenha ? 'bi-eye-slash' : 'bi-eye'"
                      (click)="toggleSenha()"
                      role="button"
                      aria-label="Alternar visibilidade da senha"
                    ></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Aba 3: Dados Pessoais -->
            <div class="tab-pane fade" id="pills-pessoal" role="tabpanel">
              <div formGroupName="dadosPessoais" class="dados-pessoais-wrapper">
                <div class="dados-pessoais-fields">
                  <div class="row g-3">
                    <!-- Cargo -->
                    <div class="col-md-6">
                      <label class="form-label">Cargo</label>
                      <select class="form-select" formControlName="idFuncao">
                        <option [ngValue]="null" disabled>Selecione</option>
                        <option *ngFor="let f of funcoes" [ngValue]="f.id">{{ f.nome }}</option>
                      </select>
                    </div>

                    <!-- Salário Base -->
                    <div class="col-md-6">
                      <label class="form-label">Salário Base</label>
                      <input type="number" class="form-control" formControlName="salarioBase">
                    </div>

                    <!-- Data de Admissão -->
                    <div class="col-md-6">
                      <label class="form-label">Data de Admissão</label>
                      <input type="date" class="form-control" formControlName="dataAdmissao">
                    </div>

                    <!-- Setor -->
                    <div class="col-md-4">
                      <label class="form-label">Setor</label>
                      <select class="form-select" formControlName="idSetor">
                        <option [ngValue]="null" disabled>Selecione</option>
                        <option *ngFor="let s of setores" [ngValue]="s.id">{{ s.nome }}</option>
                      </select>
                    </div>

                    <!-- Unidade -->
                    <div class="col-md-4">
                      <label class="form-label">Unidade</label>
                      <select class="form-select" formControlName="idUnidade">
                        <option [ngValue]="null" disabled>Selecione</option>
                        <option *ngFor="let u of unidades" [ngValue]="u.id">{{ u.nome }}</option>
                      </select>
                    </div>

                    <!-- Jornada -->
                    <div class="col-md-4">
                      <label class="form-label">Jornada</label>
                      <select class="form-select" formControlName="idJornadaTrabalho">
                        <option [ngValue]="null" disabled>Selecione</option>
                        <option *ngFor="let j of jornadas" [ngValue]="j.id">{{ j.nome }}</option>
                      </select>
                    </div>

                    <!-- Gênero -->
                    <div class="col-md-12">
                      <label class="form-label">Gênero</label>
                      <input type="text" class="form-control" formControlName="genero">
                    </div>
                  </div>
                </div>

                <div class="dados-pessoais-photo">
                  <div class="photo-upload-card">
                    <div class="photo-frame">
                      <div class="photo-preview" [class.has-photo]="photoPreview" (click)="openCropperFromPreview()" role="button" tabindex="0">
                        <img *ngIf="photoPreview; else usuarioPlaceholder" [src]="photoPreview" alt="Pré-visualização da foto">
                        <button *ngIf="photoPreview" type="button" class="btn btn-outline-light btn-sm photo-edit-action">
                          <i class="bi bi-arrows-move me-1"></i> Ajustar
                        </button>
                      </div>
                    </div>
                    <ng-template #usuarioPlaceholder>
                      <div class="photo-placeholder">
                        <i class="bi bi-camera fs-1 text-primary"></i>
                        <p class="text-muted mb-0 text-center">Adicione uma foto do usuário</p>
                      </div>
                    </ng-template>
                  </div>
                  <div class="photo-actions">
                    <input type="file" class="d-none" id="fotoUsuario" accept="image/*" (change)="onPhotoSelected($event)">
                    <label class="btn btn-primary-yellow w-100" for="fotoUsuario">
                      <i class="bi bi-upload me-2"></i>Selecionar foto
                    </label>
                    <button *ngIf="photoPreview" type="button" class="btn btn-outline-danger w-100" (click)="removePhoto()">
                      <i class="bi bi-x-circle me-1"></i>Remover foto
                    </button>
                    <p *ngIf="photoFileName" class="photo-file-name text-muted small mt-2 mb-0">
                      {{ photoFileName }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Aba 4: Contato e Endereço -->
            <div class="tab-pane fade" id="pills-contato" role="tabpanel">
              <div class="row g-3">
                <div class="col-12">
                  <h6>Contato Pessoal e de Emergência</h6>
                </div>

                <div formGroupName="contato" class="contents row g-3">
                  <div class="col-md-4">
                    <label class="form-label">Celular Pessoal</label>
                    <input type="text" class="form-control" formControlName="telefoneCelular">
                  </div>

                  <div class="col-md-4">
                    <label class="form-label">Nome (Emergência)</label>
                    <input type="text" class="form-control" formControlName="contatoEmergencia">
                  </div>

                  <div class="col-md-4">
                    <label class="form-label">Telefone (Emergência)</label>
                    <input type="text" class="form-control" formControlName="telefoneEmergencia">
                  </div>
                </div>

                <div class="col-12 mt-4">
                  <h6>Endereço</h6>
                </div>

                <div formGroupName="endereco" class="contents row g-3">
                  <div class="col-md-4">
                    <label class="form-label">CEP</label>
                    <input type="text" class="form-control" formControlName="cep" (blur)="buscarCep()" placeholder="12345-678">
                  </div>

                  <div class="col-md-8">
                    <label class="form-label">Logradouro</label>
                    <input type="text" class="form-control" formControlName="logradouro">
                  </div>

                  <div class="col-md-3">
                    <label class="form-label">Número</label>
                    <input type="text" class="form-control" formControlName="numero">
                  </div>

                  <div class="col-md-5">
                    <label class="form-label">Bairro</label>
                    <input type="text" class="form-control" formControlName="bairro">
                  </div>

                  <div class="col-md-4">
                    <label class="form-label">Cidade</label>
                    <input type="text" class="form-control" formControlName="cidade">
                  </div>

                  <div class="col-md-2">
                    <label class="form-label">UF</label>
                    <input type="text" maxlength="2" class="form-control" formControlName="estado">
                  </div>

                  <div class="col-md-10">
                    <label class="form-label">Complemento</label>
                    <input type="text" class="form-control" formControlName="complemento">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Rodapé -->
        <div class="form-footer p-3 text-end">
          <button type="submit" class="btn btn-submit fw-bold px-4 py-2" [disabled]="usuarioForm.invalid">
            Cadastrar Usuário
          </button>
        </div>
      </form>
    </div>
  </div>


<div class="cropper-backdrop" *ngIf="isCropperOpen">
  <div class="cropper-modal">
    <div class="cropper-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Ajustar Foto</h5>
      <button type="button" class="btn-close" aria-label="Fechar" (click)="closeCropper()"></button>
    </div>
    <div class="cropper-body">
      <image-cropper
        #imageCropper
        [imageChangedEvent]="imageChangedEvent"
        [imageBase64]="imageBase64 ?? undefined"
        [roundCropper]="true"
        [maintainAspectRatio]="false"
        [containWithinAspectRatio]="true"
        [autoCrop]="true"
        [cropperStaticWidth]="320"
        [cropperStaticHeight]="320"
        [resizeToWidth]="400"
        [imageQuality]="100"
        [transform]="transform"
        format="png"
        (imageCropped)="onImageCropped($event)">
      </image-cropper>
      <div class="cropper-controls">
        <label class="form-label">Zoom</label>
        <input type="range" min="1" max="3" step="0.1" [value]="cropperScale" (input)="onZoomInput($event)">
      </div>
    </div>
    <div class="cropper-footer d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-light" (click)="closeCropper()">Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="confirmCrop()">Aplicar recorte</button>
    </div>
  </div>
</div>
>